import {
  MobileSelectionList,
  MobileSelectionListItem,
} from "common/components/MobileSelectionList";
import ProfileHeading from "common/components/ProfileHeading";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { LinkedInProfile } from "common/types";

import { LIST_LEADS_COLUMNS } from "../../../../constants";

interface MobileListProps {
  leads: LinkedInProfile[];
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
  selectedLeads: LinkedInProfile[];
  setSelectedLeads: (selectedLeads: LinkedInProfile[]) => void;
}

export default function MobileList({
  leads,
  isLoading,
  pageSize,
  totalItemCount,
  selectedLeads,
  setSelectedLeads,
}: MobileListProps) {
  const { permissions } = useSelectedWorkspaceContext();

  return (
    <MobileSelectionList
      title="Excluded"
      data={leads || new Array(pageSize).fill(null)}
      selection={selectedLeads}
      onSelectionChange={
        isLoading
          ? undefined
          : (newSelection) =>
              setSelectedLeads(newSelection === "all" ? leads : newSelection)
      }
      allItems={LIST_LEADS_COLUMNS}
      totalDataCount={totalItemCount}
      canSelectAll={false}
    >
      {(lead, listItemProps) => {
        const { id, picture_url, full_name, occupation } = lead;

        return (
          <MobileSelectionListItem
            {...listItemProps}
            relativeTo={
              permissions.includes("leads_full") ? `leads/${id}` : undefined
            }
          >
            {isLoading ? (
              <ProfileHeading isLoading />
            ) : (
              <ProfileHeading
                fullName={full_name}
                pictureUrl={picture_url}
                occupation={occupation}
              />
            )}
          </MobileSelectionListItem>
        );
      }}
    </MobileSelectionList>
  );
}
